import React from "react";
import Form from "../../common/form";
import http, {getApiUrl} from "../../../services/http/httpService";
import schema from './loginFormSchema';

class LoginForm extends Form {

    constructor() {
        super();
        this.setDataAndSchema();
    }

    baseInformation = schema;

    //   username = React.createRef();

    // componentDidMount = () => {
    //     this.username.current.focus();
    //   }


    doSubmit = async () => {
        const {username, password} = this.state.data;
        const {configurations} = this.props;

        let newUsername = username;
        if (
            configurations &&
            configurations.mandatoryNumber &&
            configurations.mandatoryNumber !== "noMandator"
        ) {
            newUsername = configurations.mandatoryNumber + "." + username;
        }

        const credentials = {
            username: newUsername,
            password: password
        };
        const url = getApiUrl() + "/api/login";

        // console.log("LoginForm.doSubmit(): url=", url, ", credentials=", credentials);
        const loginRequest = await http.post(url, credentials);
        this.props.handleSetCredentials(loginRequest.data, true);
    };

    onLogin = () => {
        const errors = this.validate();
        if (errors && errors.length > 0) {
            this.setState({errors});
            return;
        }
        this.doSubmit();
    };

    onConfiguration = () => {
        this.props.handleSetConfigurations({
            mandatoryNumber: "/login",
            deviceSerialNumber: ""
        });
    };

    render = () => {
        return (
            <div>
                <h1>Login</h1>
                {/* <form onSubmit={this.handleSubmit}> */}
                {this.renderField({"name": "username"})}
                {this.renderField({"name": "password"})}
                <React.Fragment>
                    <div className="btn-toolbar" role="toolbar">
                        {this.renderButton({
                            label: "Anmelden",
                            disabled: this.validate(),
                            onClick: this.onLogin
                        })}
                        {this.renderButton({
                            label: "Konfiguration",
                            onClick: this.onConfiguration
                        })}
                    </div>
                </React.Fragment>
                {/* </form> */}
            </div>
        );
    }
}

export default LoginForm;
